<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin, getUrlFromPath } from "src/modules/interactions_module.js";
import { get } from "lodash";
import MediaElementPlayer from 'mediaelement/build/mediaelement-and-player';

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  data: function () {
    return {
      shareUrl: "",
      videoMetadata: {
        width: null,
        height: null,
      }
    };
  },
  mounted: function() {
    Vue.nextTick(() => {
      const video = this.$refs["video-player"];
      video.onloadedmetadata = () => {
        this.videoMetadata.height = video.videoHeight;
        this.videoMetadata.width = video.videoWidth;
        new MediaElementPlayer(this.$refs["video-player"], {
          stretching: "responsive",
          hideVolumeOnTouchDevices: false,
          success: function(media, node, instance) {
            media.play();
            media.setMuted(true);
          }
        });
      };
    });
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    startLinkShare() {
      this.copyToClipboard();
      this.updateShareInteraction(this.containerContent, this.content, this.shareInteraction.interaction, "link", this.sharePath, false);
    },
    copyToClipboard() {
      this.shareUrl = getUrlFromPath(this.sharePath, this.isIframe, this.content.name);
      const el = document.createElement("textarea");
      el.value = this.shareUrl;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      $(this.$refs["modal"]).appendTo("body").modal("show");
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    }
  },
  computed: {
    orientationClass() {
      return this.videoMetadata.width > this.videoMetadata.height ? "horizontal" : "vertical";
    },
    owner() {
      return (Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) ? this.pageModel.id_to_user[this.content.owned_by] : null;
    },
    voteInteraction() {
      return (this.content.interactions && this.content.interactions["vote"]) ? this.content.interactions["vote"] : false;
    },
    shareInteraction() {
      return (this.content.interactions && this.content.interactions["share"]) ? this.content.interactions["share"] : false;
    },
    userHasVoted() {
      return this.voteInteraction ? (this.isInteractionDone(this.containerContent, this.content.interactions["vote"].interaction) ? true : false ) : false;
    },
    numberOfVotes() {
      let numberOfVotes = 0;
      if(this.voteInteraction) {
        const contentUserInfo = this.getContentUserInfo(this.containerContent);
        numberOfVotes = get(contentUserInfo, ["id_to_interaction", this.content.interactions["vote"]["interaction"].id, "votes_info", "number_of_votes"], 0);
      }
      return numberOfVotes;
    },
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="position-relative" >
    <component :is="stripe.layout" :content="stripe" v-for="stripe in content.heading_stripes" :key="stripe.$id" :opt-container-content="containerContent"></component>
    <div class="container page-ugc-video-contest pt-5">
      <div class="row justify-content-center px-2 px-sm-0">
        <div class="col-12 col-sm-10 col-md-9 col-xl-8 px-1 px-md-0 justify-content-between align-items-center page-ugc-video-contest__header d-flex">
          <div class="user-info-container d-flex">
            <div v-if="owner.avatar" class="user-info-content__avatar mr-3" :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"></div>
            <div class="align-items-center d-flex text-kenwood-dark-grey">By {{owner.first_name}} {{owner.last_name ? `${owner.last_name[0]}.` : ''}}
            </div>
          </div>
          <div class="vote-container">
            <div v-if="voteInteraction" class="votes-counter px-2 bg-cheddar d-flex align-items-center justify-content-center">
              <div class="counter-number pr-1">{{numberOfVotes}}</div>
              <svg id="star-icon"><use :xlink:href="userHasVoted ? '#star' : '#star-o'"></use></svg>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-10 col-md-9 col-xl-8 d-flex justify-content-center bg-black my-3 p-0">
          <div :class="orientationClass" class="page-ugc-video-contest__video-player__container d-flex justify-content-center">
            <video width="100%" height="100%" id="video-player" class="mejs__player" muted="muted" ref="video-player" webkit-playsinline playsinline controls>
              <source type="video/mp4" :src="content.transcoded_video.url">
            </video>
          </div>
        </div>
        <div class="col-12 col-sm-10 col-md-9 col-xl-8 px-0 pb-5 pt-2 page-ugc-video-contest__buttons d-flex justify-content-center">
          <button role="button" class="btn btn-kenwood-mid-grey wm-50 mr-1 px-3" @click="startLinkShare()" >{{ft("vote.share")}}</button>
          <template v-if="voteInteraction">
            <button v-if="!userHasVoted" role="button" class="btn btn-cheddar wm-50 ml-1 px-3"
              @click="updateVoteInteraction(containerContent, voteInteraction, voteInteraction.interaction, 1,)">
              {{ft("vote.vote")}}
            </button>
            <button v-else role="button" class="btn btn-kenwood-light-grey wm-50 ml-1 px-3">{{ft("vote.thanks")}}</button>
          </template>
        </div>
      </div>
    </div>
    <component :is="stripe.layout" :content="stripe" v-for="stripe in content.stripes" :key="stripe.$id" :opt-container-content="containerContent"></component>
    <!-- share link modal -->
    <div class="modal fade" ref="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header position-relative border-0">
            <h5 class="h4 w-100 d-inline-block text-center">{{ft("globals.share_with_friends")}}</h5>
            <button type="button" class="close m-0 p-0" data-dismiss="modal" aria-label="Close">
              <i aria-hidden="true" class="fal fa-times text-black"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="input-group">
              <textarea class="w-100 form-control" ref="textarea" v-model="shareUrl"></textarea>
            </div>
            <div class="py-3 text-center text-kenwood-dark-grey">
              (link copiato negli appunti)
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<style lang="scss">

  .wm-50 {
    width: 14rem;
  }

  svg#star-icon{
    stroke: $black;
    width: 1.1rem;
    height: 1.1rem;
  }

  .page-ugc-video-contest__header {

    .user-info-container {
      flex: 1;

      .user-info-content__avatar {
        background-position: center;
        background-size: cover;
        border-radius: 50%;
        height: 4rem;
        width: 4rem;
      }

    }

    .votes-counter {
      height: 2rem;
      min-width: 4rem;
      border-radius: 1rem;
      top: 0.75rem;
      right: 0.5rem;

      .counter-number {
        padding-top: 3px;
        color: $black;
      }

    }

  }

  .page-ugc-video-contest__video-player__container {

    &.horizontal {
      width: 100%;
      video {
        max-width: 100%;
      }
    }

    &.vertical {
      width: 48vh;
    }

  }

  @include media-breakpoint-down(xs) {
    .wm-50 {
      width: 50%;
    }
  }

</style>